(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-manuals"] && !Shopify.designMode) return;
  try {
    

    async function domReady(fn){
        document.addEventListener("DOMContentLoaded", fn);
        if (document.readyState === "interactive" || document.readyState === "complete" ) {
            return document.readyState
        }
    }

    domReady().then(()=>{
        var be_video_player = document.querySelector('#be-manuals-videoplayer');
        document.querySelectorAll('.be-internal-video').forEach((item)=>{
            item.addEventListener('click',(el)=>{

                var videoUrl = el.target.getAttribute('data-video-url')
                if(videoUrl == null){
                    videoUrl = el.target.parentNode.getAttribute('data-video-url')
                }
        
                if(window.innerWidth <= 768){
                    document.querySelectorAll(`.be-manual-mobile-video,.video-visible`).forEach((el)=>{
                        if(el.tagName == 'VIDEO'){
                            el.pause()
                            el.classList.contains('visible') ? el.classList.remove('visible') : null
                        } else {
                            el.classList.contains('video-visible') ? el.classList.remove('video-visible') : null
                        }
                    })

                    var mobile_player = document.querySelector(`.be-manual-mobile-video[data-video="${videoUrl}"]`)
                    mobile_player.parentNode.classList.add('video-visible')
                    mobile_player.classList.add('visible')
                    mobile_player.play()

                } else {
                    be_video_player.pause()
                    be_video_player.setAttribute('src',videoUrl)
                    be_video_player.scrollIntoView();
                    be_video_player.play()
                }
            })
        })
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
